<script setup>

const { locale } = useI18n()
const url = useRequestURL()

const story = ref(null)

const { data: pageInit } = await useAPIFetch('StoryOfSupraphon')
const pageText = pageInit.value.body.find(item => item.component === 'Text')
const storyList = pageInit.value.body.find(item => item.specific === 'StoryList')
const componentId = ref(storyList.id)
const isLoading = ref(false)
const limit = ref(storyList.params.limit || 9)

const timeline = ref(["2020's","2010's","2000's","1990's","1980's","1970's","1960's","1950's","1940's","1930's","1920's"])
const selectedDecade = ref(2020)

const { data: page } = await useAPIFetch(`StoryOfSupraphon/component/${componentId.value}?filter=published>${selectedDecade.value}`, {
	query: {
		'limit': limit.value,
		'orderBy': 'published-desc'
	}
})
const cursor = ref(page.value.cursor)
let items = ref(page.value.items)

const loadMore = async () => {
	isLoading.value = true
	const result = await useUIFetch(locale.value, `StoryOfSupraphon/component/${componentId.value}`, {
		'cursor': cursor.value,
		'limit': limit.value,
		'orderBy': 'published-desc'
	})

	items.value = [...items.value, ...result.items]
	cursor.value = result.cursor
	isLoading.value = false
}

const selectDecade = async (decade) => {
	selectedDecade.value = parseInt(decade)
	const nextDecade = selectedDecade.value + 10
	isLoading.value = true
	const result = await useUIFetch(locale.value, `StoryOfSupraphon/component/${componentId.value}?filter=published>${selectedDecade.value}|published<${nextDecade}`, {
		'limit': limit.value,
		'orderBy': 'published-desc'
	})

	items.value = [...result.items]
	cursor.value = result.cursor
	isLoading.value = false
}

useHeadData({
	title: pageInit.value.meta.title,
	description: pageInit.value.meta.description,
	author: pageInit.value.meta.author,
	copyright: pageInit.value.meta.copyright,
	keywords: pageInit.value.meta.keywords,
	og: pageInit.value.meta.og,
	url: url.href
})

</script>

<template>
	<div class="container">
		<h1 class="text-red xl:text-center mb-5 xl:mb-10">{{ pageInit.attrs.title }}</h1>
		<div class="max-w-[865px] mx-auto xl:text-center">
			<WysiwygPerex :value="pageInit.attrs.perex" />
			<WysiwygText :value="pageText.content" />
		</div>

		<div class="decades flex gap-4 xl:justify-center dark:text-light text-dark tracking-[-0.36px] text-xl xl:text-2xl mt-8 xl:mt-28">
			<a
				v-for="item in timeline"
				:key="item"
				href="#"
				class="link in-list"
				:class="{'is-active' : parseInt(item) === selectedDecade}"
				@click.prevent="selectDecade(item)"
			>
				{{ item }}
			</a>
		</div>
		
		<div v-if="items.length" class="w-full mt-12 xl:mt-20" ref="story">

			<div class="xl:text-center mb-4 xl:mb-10">
				<h3 class="h1 dark:text-light text-dark">{{ selectedDecade }}'s</h3>
			</div>

			<StoryItem v-for="item in items" :key="item.id" :item="item" />
			<div class="h-[150px]">
				<LoadMore @click="loadMore()" v-if="cursor" :loading="isLoading" smallGrid />
			</div>

		</div>
		
	</div>
</template>

<style lang="scss" scoped>
	.decades {
		-ms-overflow-style: none;
		scrollbar-width: none;
		overflow-x: scroll;

		&::-webkit-scrollbar {
			display: none;
		}
	}
</style>